// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M4 8V4h16v10H4Zm0-6h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5.59l6 6H17.6L13 17.41V22h-2v-4.59L6.41 22H3.6l6-6H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"
    />
  </BaseIcon>
)
